import React, {useEffect, useState} from 'react';
import CreateForm from "./CreateForm";
import {Form} from "react-bootstrap";
import {IDriverRegistration} from "../interface";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ErrorToast, SuccessToast} from "../../../shared/toasters/toasters";
import {AdminDriverRegistrationService} from "../service";
import {IBrand} from "../../brand/interface";
import {AdminBrandService} from "../../brand/service";

const CreateDriver = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const [state, setState] = useState<IDriverRegistration | null>(null);
    const [brands, setBrands] = useState<IBrand[]>([]);

    useEffect(() => {
        AdminBrandService.getAll({ page: 1, perPage: 0 })
            .then((response) => {
                const { data } = response;
                setBrands(data?.items ?? []);
            })
            .catch(ErrorToast);

    }, []);
    const submitHandler = () => {
        AdminDriverRegistrationService.create({
            ...state,
            brands: state?.brands || [],
        })
            .then(() => {
                SuccessToast(t("driver_registration.successfully_created"));
                navigate(-1);
                setState(null);
            })
            .catch(ErrorToast);
    };


    useEffect(() => {
        setState({
            brands: [],
            residesInAustria: false,
            residesOutsideAustria: false,
            classBLicense2Years: false,
            prizeDraws: false,
            emailInfo: false,
            active: false,
        } as IDriverRegistration);
    }, []);

    return (
        <div className="col-12">
            <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    submitHandler();
                }}
            >
                <CreateForm state={state} setState={setState} brands={brands}/>
            </Form>
        </div>
    );
};

export default CreateDriver;